module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-4-photo-8-ab1d63f50bc70b16fbcf7f1ba7b7f232.webp";